<div class="grid">
  <div class="col">
    <p-table
      [paginator]="true"
      [rows]="25"
      [showCurrentPageReport]="true"
      [rowsPerPageOptions]="rowsPerPageOptions"
      [totalRecords]="(attachmentList || []).length"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="Risultati {first} - {last} di {totalRecords} totali"
      [value]="attachmentList || []">
      <ng-template pTemplate="header">
        <tr>
          <th>Nome</th>
          <th>Dim.</th>
          <th>Tipologia</th>
          <th>Data caricamento</th>
          <th></th>
        </tr>
      </ng-template>
      <ng-template
        pTemplate="body"
        let-media>
        <tr>
          <td>{{ media.media.original_name }}</td>
          <td>{{ media.media.size | filesize }}</td>
          <td>{{ media.attachment_type.type_description }}</td>
          <td>{{ media.media.created_on | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
          <td>
            <div class="table-actions">
              <p-button
                icon="pi pi-trash"
                *hasGrants="deleteGrants"
                class="butt"
                (click)="confirmDelete(media)"
                pTooltip="Elimina"
                tooltipPosition="top"></p-button>
              <p-button
                icon="pi pi-download"
                class="butt"
                (click)="download(media)"
                pTooltip="Scarica allegato"
                tooltipPosition="top"></p-button>
            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="5">Nessun allegato</td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <div
    class="col-6"
    *hasGrants="createGrants">
    <p-fileUpload
      #uploader
      chooseLabel="Aggiungi"
      uploadLabel="Carica"
      cancelLabel="Annulla"
      [multiple]="true"
      [customUpload]="true"
      (uploadHandler)="onUpload($event)"
      (onSelect)="onSelectedFiles($event)"
      (onClear)="clearQueue()"
      [disabled]="uploading"
      [showCancelButton]="!uploadCompleted && !uploading"
      [showUploadButton]="!uploadCompleted && !uploading"
      [maxFileSize]="1000000000">
      <ng-template
        pTemplate="content"
        let-files>
        <ng-container *ngIf="uploadQueue.length > 0">
          <div class="file-list">
            <div
              class="item"
              *ngFor="let u of uploadQueue; let index = index">
              <div class="name">{{ u.file.name }}</div>
              <div class="size">{{ u.file.size | filesize }}</div>
              <div
                class="type"
                *ngIf="(u.progress | async) === -1">
                <p-dropdown
                  [options]="attachments"
                  [(ngModel)]="u.attachment_type_id"
                  optionLabel="type_description"
                  optionValue="id"
                  appendTo="body"
                  [required]="true"
                  dataKey="id"
                  placeholder="Tipologia allegato"></p-dropdown>
              </div>
              <div class="actions text-center">
                <ng-container [ngSwitch]="u.progress | async">
                  <ng-container *ngSwitchCase="-1">
                    <p-button
                      label="Rimuovi"
                      severity="danger"
                      icon="pi pi-exclamation-triangle"
                      [outlined]="true"
                      class="p-button-outlined text"
                      (click)="removeFromQueue($event, index)" />
                  </ng-container>
                  <ng-container *ngSwitchCase="-2">
                    <i class="pi pi-times text-red-300"></i>
                  </ng-container>
                  <ng-container *ngSwitchCase="100">
                    <ng-container *ngIf="u.result">
                      <i class="pi pi-check text-green-600"></i>
                    </ng-container>
                    <ng-container *ngIf="!u.result">
                      <i class="pi pi-times text-red-300"></i>
                    </ng-container>
                  </ng-container>
                  <ng-container *ngSwitchDefault>
                    <i class="pi pi-spin pi-spinner text-color-nes-teal"></i>
                  </ng-container>
                </ng-container>
              </div>
            </div>
          </div>
        </ng-container>
      </ng-template>
      <ng-template pTemplate="file"></ng-template>
    </p-fileUpload>
  </div>
</div>
